<template>
	<div class="modal-wrapper">
		<div class="full-container bg-white">
			<div class="modal-inner">
				<button class="modal-btn" @click="onClose">
					&times;
				</button>
				<div class="modal-title">
					<span v-if="options.type === 'team'">{{ $tc('common.teamSubscription') }}</span><span v-else>{{ $tc('common.clubSubscription') }}</span> {{ $tc('plans.wizard.installment.modalTitleText') }}
				</div>
				<p v-html="$t('plans.wizard.installment.modalTopText')" />
				<div class="table-wrap">
					<table>
						<thead>
							<tr>
								<th>{{ $tc('plans.wizard.installment.tableHeadText[0]') }}</th>
								<th>{{ $tc('plans.wizard.installment.tableHeadText[1]') }}</th>
								<th>{{ $tc('plans.wizard.installment.tableHeadText[2]') }}</th>
								<th>{{ $tc('plans.wizard.installment.tableHeadText[3]') }}</th>
								<th>{{ $tc('plans.wizard.installment.tableHeadText[4]') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="plan in options.plans" :key="plan.descr">
								<td>{{ $tc(`plans.wizard.installment.plans[${plan.period}]`) }}</td>
								<td>{{ plan.period }}</td>
								<td>
									<number :duration="0.75" :format="$filters.formatCurrencyDecimal" :to="plan.monthly" easing="Power1.easeInOut" />
								</td>
								<td>
									<number :duration="0.75" :format="$filters.formatCurrencyDecimal" :to="plan.total" easing="Power1.easeInOut" />
								</td>
								<td>
									{{ $tc('plans.wizard.installment.saveText') }} <number :duration="0.75" :format="$filters.formatCurrency" :to="plan.save" easing="Power1.easeInOut" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<p>{{ $tc('plans.wizard.installment.modalBottomText') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardInstallment',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
$border: #4d4d4d;

.full-container {
	.table-wrap {
		overflow: auto;
	}
	table {
		border-collapse: collapse;
		width: 100%;
		border-top: 1px solid $border;
		border-right: 1px solid $border;
		font-size: 18px;
		margin-bottom: 33px;
		th, td {
			border-bottom: 1px solid $border;
			border-left: 1px solid $border;
			&:first-child,
			&:last-child {
				text-align: left;
			}
			&:last-child {
				min-width: 200px;
			}
		}
		thead {
			th {
				background-color: #009bc9;
				color: #fff;
				font-weight: 500;
				padding: 8px 35px;
			}
		}
		tbody {
			tr {
				background-color: #f5f5f5;
				td {
					text-align: center;
					padding: 17px 35px;
					white-space: nowrap;
					&:first-child {
						text-align: left;
					}
					&:last-child {
						text-align: left;
						background-color: #eaeaea;
						font-weight: 500;
					}
				}
			}
		}
	}
}

@media screen and (max-width: 1279px) {
	.full-container .modal-inner {
		table {
			margin-bottom: 20px;
			thead th,
			tbody tr td {
				padding-left: 20px;
				padding-right: 20px;
			}
		}
	}
}
</style>
